import { store } from '../store';
import { api } from './config/axios';

const getConfig = () => {
  const { token } = store.getState().auth;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const getCampaigns = () => {
  return api.get('/api/v1/admin/campaigns', {}, getConfig());
};

export const createCampaign = (data) => {
  return api.post('/api/v1/admin/campaigns', data, getConfig());
};

export const getCampaign = (campaignId) => {
  return api.get(`/api/v1/admin/campaigns/${campaignId}`, {}, getConfig());
};

export const updateCampaign = (campaignId, data) => {
  return api.put(`/api/v1/admin/campaigns/${campaignId}`, data, getConfig());
};

export const deleteCampaign = (campaignId) => {
  return api.delete(`/api/v1/admin/campaigns/${campaignId}`, {}, getConfig());
};
